import React, { useState, useEffect } from 'react';
import { Button, Modal, Icon } from 'semantic-ui-react';
import { Formik, Field as Fieldmik } from 'formik';
import moment from 'moment';
import AddProduct from '../../../../purchaseOrder/addProduct'
import LoadingPlaceholder from '../../../../placeholderComponent/loadingPlaceholder';


const PoDetails = (props) => {
    const [modalOpen, setmodalOpen] = useState(false);

    let handleOpen = () => setmodalOpen(true);
    let handleClose = () => {
        setmodalOpen(false);

    };

    let handleSubmitting = (data) => {
        console.log(data);
        if (data) {
            props.refreshOrders(data)
        }
    }


    // if(purchaseOrderDetails.length === 0) {
    //     return (<LoadingPlaceholder />)
    // } else {


    const { vendorBranch, branch } = props.formValues
    const customerNo = localStorage.getItem('customerNumber')

    return (
        <Modal
            style={{ overflow: "inherit" }}
            open={modalOpen}
            onClose={handleClose}
            size={vendorBranch && branch ? "fullscreen" : "small"}
            trigger={
                <Button
                    type="button"
                    onClick={() => handleOpen()}
                    size="mini"
                    circular
                    basic className="ml-2 w3-tiny"
                    icon
                >
                    <Icon name="info" color="grey" size='small' />

                </Button >
            }

        >
            <Modal.Content>
                { vendorBranch && branch ? 
                <AddProduct
                    billmode="view"
                    poId={props.poId}
                    masterState={props.masterState}
                    masterBranch={props.masterBranch}
                    vendorStateId={props.vendorStateId}
                    isGstApplicable={props.isGstApplicable}
                    formValues={props.formValues}
                    updatePurchaseOrder={props.updatePurchaseOrder}
                    viewmode={props.viewmode}
                    handleClose={handleClose}
                    isSubmitted={handleSubmitting}
                />

                :

                customerNo != 1158 ?
                <>Select <b>Vendor Branch</b> and <b>Vendor</b> to add Additional Charges.</>
                :
                <>Select <b>Partner Branch</b> and <b>Branch</b> to add Additional Charges.</>
                }
            </Modal.Content>
        </Modal >
    )
}


export default PoDetails
